import { Grid2, Typography } from "@mui/material";
import { Fragment } from "react";

const UIText = {
  "es-CL": { label: "Archivos cargados simultaneamente" },
  "en-US": { label: "Simultaneous uploaded files" },
};

const Upload = ({ multiple, locale }) => {
  const { label } = UIText[locale];

  return (
    <Fragment>
      <Grid2 container size={6}>
        <Typography>{label}</Typography>
      </Grid2>
      <Grid2 container size={6}>
        <Typography>{multiple}</Typography>
      </Grid2>
    </Fragment>
  );
};

export default Upload;
